"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheMuseCollective() {
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -10% 0px"
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    rootMargin: "0px 0px -10% 0px"
  });
  return <section data-section-id="223725" id="built-by-tech-for-tech" className="bg-background text-foreground w-full min-h-screen flex flex-col lg:flex-row overflow-hidden">
      {}
      <div className="lg:w-[60%] relative min-h-[60vh] lg:min-h-screen overflow-hidden bg-card">
        <div ref={imgRef} className={`absolute inset-0 w-full h-full transition-transform duration-[2000ms] ease-out ${isImgVisible ? "scale-100" : "scale-110"}`}>
          {}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639306/img/muse_team_studio_bw.png" alt="SMB IT Tech Leadership Team in a modern startup environment" className="w-full h-full object-cover sepia-[.15] contrast-110 brightness-75" />
          {}
          <div className="absolute inset-0 bg-primary/10 mix-blend-overlay"></div>
        </div>
      </div>

      {}
      <div className="lg:w-[40%] flex flex-col justify-center px-6 py-20 md:px-16 lg:px-20 xl:px-24 bg-background z-10 relative">
        <div ref={contentRef} className={`transition-all duration-1000 delay-300 ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <span className="text-primary font-mono text-xs md:text-sm tracking-widest mb-10 block uppercase">
            01 &mdash; THE FRACTIONAL MODEL
          </span>

          {}
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-[1.1] tracking-tighter mb-12 text-foreground">
            Built by Tech,<br />
            for the Future of Tech.
          </h2>

          {}
          <div className="space-y-8 text-muted-foreground font-default text-base md:text-lg leading-relaxed">
            <p className="font-light">
              At SMB IT Tech, we don't just resolve tickets; we integrate into your core workflow. We view fractional IT as a strategic mindset—becoming an internal partner that scales alongside your startup's velocity.
            </p>
            <p className="font-bold text-foreground text-xl md:text-2xl leading-snug">
              Our model is built on radical transparency: a flat $110 per device covers our enterprise-grade RMM tool, dedicated end-user support, and critical Windows updates.
            </p>
            <p className="font-light">
              We include comprehensive O365 support at no extra cost, providing licensing through our tenant with zero markup. We understand high-stakes environments because we are built by tech, for tech, ensuring your infrastructure is an asset, not a bottleneck.
            </p>
          </div>
        </div>
      </div>
    </section>;
}